import Image from 'next/image'
import type { ArticlePortraitData } from '@/app/blog/articlePortraits'

export default function ArticlePortrait({ portrait }: { portrait: ArticlePortraitData }) {
  return (
    <figure className="mb-8 overflow-hidden rounded-2xl border border-ink/10 bg-[#F7F5F0]">
      <div className="grid sm:grid-cols-[1.05fr_1fr]">
        <div className="relative aspect-[4/3] bg-forest/10 sm:aspect-auto sm:min-h-[440px]">
          <Image
            src={portrait.image}
            alt={portrait.alt}
            fill
            className="object-cover"
            style={{ objectPosition: portrait.position }}
            sizes="(max-width: 639px) calc(100vw - 32px), (max-width: 1024px) 46vw, 460px"
            preload
          />
        </div>
        <div className="flex flex-col justify-center px-6 py-8 sm:px-9 sm:py-12">
          <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-forest sm:text-xs">
            {portrait.context}
          </p>
          <p className="mt-5 text-sm font-medium text-ink/65">{portrait.name}</p>
          <p className="mt-2 max-w-xs font-display text-3xl font-bold leading-tight text-ink sm:text-4xl">
            {portrait.headline}
          </p>
          <div className="my-5 h-px w-10 bg-forest/35" aria-hidden="true" />
          <p className="max-w-sm text-sm leading-relaxed text-gray-700 sm:text-base">
            {portrait.description}
          </p>
        </div>
      </div>
      <figcaption className="border-t border-ink/10 bg-white px-5 py-3 text-xs leading-relaxed text-gray-500 sm:px-6">
        {portrait.caption}{' '}
        <a href={portrait.sourceUrl} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-forest">
          Photo: {portrait.credit}
        </a>{' '}
        ·{' '}
        <a href={portrait.licenseUrl} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-forest">
          {portrait.license}
        </a>
        {' · Framed to fit. Editorial coverage; no endorsement implied.'}
      </figcaption>
    </figure>
  )
}
